<div class="border-1 surface-border border-round p-4">
  <em-coverage-card i18n-title title="Assurance permanente">
    <p-dropdown
      [options]="coverageAmountOptions"
      [filter]="true"
      [virtualScroll]="true"
      [virtualScrollItemSize]="30"
      filterBy="value"
      filterMatchMode="startsWith"
      [formControl]="form.controls.coverageAmount"
      optionLabel="name"
      optionValue="value"></p-dropdown>
  </em-coverage-card>

  @if (form.controls.coverageAmount.value && withProductSelection) {
    <div class="p-5">
      <h3 class="text-primary mb-2" i18n>Choix du produit</h3>
      <p-table
        [value]="products"
        [selection]="products[selectedProductIndex]"
        (onRowSelect)="onSelect($event)"
        dataKey="value"
        selectionMode="single">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem"></th>
            <th i18n>Produit</th>
            <th class="text-right" i18n>Prime</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-lifeInsuranceProduct>
          <tr>
            <td>
              <p-tableRadioButton
                [disabled]="lifeInsuranceProduct === products[selectedProductIndex]"
                [value]="lifeInsuranceProduct"></p-tableRadioButton>
            </td>
            <td>{{ lifeInsuranceProduct.name | emTranslate }}</td>
            @if (!isPriceLoading) {
              <td class="text-right"
                >{{ (lifeInsuranceProduct.price | currency: 'CAD' : 'symbol-narrow' : '1.2-2') || '--' }}
              </td>
            }
            @if (isPriceLoading) {
              <td class="text-right">
                <p-progressSpinner
                  strokeWidth="6"
                  [style]="{width: '100%', height: '15px'}"></p-progressSpinner>
              </td>
            }
          </tr>
        </ng-template>
      </p-table>
    </div>
  }
</div>
